import { NetworkError } from '../../state-machine/actions/genericActions';
import { selectLoanHelperOTB, selectLoanHelper } from '../../helpers';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { ExistingApplicationMachineContext } from '../../state-machine/types/existingApplicationMachine.types';
import { ApplyTypes, ContractDetails, LoanOptionErrors } from '../../gql/graphql';
import loansService from '../../services/loan.service';

export interface SelectLoanOptionTypeResult {
  selectLoanOptionError?: LoanOptionErrors[];
  selectLoanOptionResponse?: ContractDetails;
}

const selectLoanOptionType = async (context: ExistingApplicationMachineContext) => {
  let loanSelectedProd;
  if (context.eligibilityDetails?.applyTypes[0] === ApplyTypes.LoanOtb) {
    loanSelectedProd = selectLoanHelperOTB(context.application?.loan?.options);
  } else {
    loanSelectedProd = selectLoanHelper(context.application?.loan?.options);
  }
  const productId = loanSelectedProd?.productID;
  try {
    const resp: any = await loansService.selectLoanOptionType({
      orderId: context.orderId,
      productId,
    });

    if (resp.data?.selectLoanOptionType?.loanOptionErrors?.length) {
      return {
        selectLoanOptionError: resp.data.selectLoanOptionType.loanOptionErrors,
      };
    } else {
      return {
        selectLoanOptionResponse: resp.data?.selectLoanOptionType?.loanSummary,
      };
    }
  } catch (err: any) {
    let error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default selectLoanOptionType;
